export const blockIconsContentRemoveCircle = (
	<span className='material-symbols-outlined'>remove_circle</span>
);
